// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.customizing-tabs .ant-tabs-ink-bar {
  display: none !important;
}

/* For animated ink bar - the selector needs a space */
.customizing-tabs .ant-tabs-ink-bar-animated {
  display: none !important;
}

.customizing-tabs .ant-tabs-tab {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-select-selector {
  outline: none !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Supplier/reporting/report/Report.css"],"names":[],"mappings":";AACA;EACE,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B","sourcesContent":["\n.customizing-tabs .ant-tabs-ink-bar {\n  display: none !important;\n}\n\n/* For animated ink bar - the selector needs a space */\n.customizing-tabs .ant-tabs-ink-bar-animated {\n  display: none !important;\n}\n\n.customizing-tabs .ant-tabs-tab {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-select-selector {\n  outline: none !important;\n  box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
